import { RouteMapItem } from "types";

type getRouteFromPathProps = {
  path: string;
  routeMap: RouteMapItem[];
};

const getRouteFromPath = ({ path = "", routeMap = [] }: getRouteFromPathProps): RouteMapItem | undefined =>
  routeMap.find((route) => route.path === path);

export default getRouteFromPath;
